<template>
  <div v-if="error !== null">
    <ErrorDetail
      v-if="error"
      :error="error" />
    <Page404
      v-else
      message="That error was not found" />
  </div>
</template>
<script>
import { mapActions } from 'vuex';
import Page404 from 'src/components/NotFoundPage.vue';
import store from './_store';
import ErrorDetail from './_components/ErrorDetail.vue';

export default {
  name: 'ErrorDetailModule',
  components: {
    ErrorDetail,
    Page404,
  },
  data() {
    return {
      error: null,
    };
  },
  beforeCreate() {
    this.$store.registerModule('$__error', store);
  },
  destroyed() {
    this.$store.unregisterModule('$__error');
  },
  async created() {
    this.error = await this.fetchError({ id: this.$route.params.id });
  },
  methods: {
    ...mapActions('$__error', [
      'fetchError',
    ]),
  },
};
</script>
